import { AccountAccessEntry, EntryTypes, IUnauthenticatedAccountRepository, NewAccountEntryResult, NewAccountRegisterResult, ResetPasswordEntryResult, ResetPasswordRegisterResult } from "../../../domain/account";
import { HttpRepository } from "../../HttpRepository";
import { IAccountAccessEntryBean, INewAccountEntryRequestBean, INewAccountEntryResultBean, INewAccountRegisterRequestBean, INewAccountRegisterResultBean, IResetPasswordEntryRequestBean, IResetPasswordEntryResultBean, IResetPasswordRegisterRequestBean, IResetPasswordRegisterResultBean } from "./beans";

export class UnauthenticatedAccountRepository extends HttpRepository implements IUnauthenticatedAccountRepository {
  async registerNewAccountEntry(accountCode: string): Promise<NewAccountEntryResult> {
    const url = "/api/account/entry";
    const request: INewAccountEntryRequestBean = {
      accountCode: accountCode,
    };
    const result = await this.post(url, request);
    return this.toNewAccountEntryResult(result.data);
  }

  private toNewAccountEntryResult(bean: INewAccountEntryResultBean): NewAccountEntryResult {
    if (!bean) { throw new Error("bean is empty!!!"); }

    const result = new NewAccountEntryResult();
    result.isOk = !!bean.isOk;
    result.isMailSendFailed = !!bean.isMailSendFailed;
    result.isAlreadyRegistered = !!bean.isAlreadyRegistered;
    return result;
  }

  async getAccountEntry(entryGuid: string, entryType: EntryTypes): Promise<AccountAccessEntry> {
    const url = "/api/account/entry/" + entryGuid;
    const query = {
      params: {
        entryType: entryType,
      },
    };
    const result = await this.get(url, query);
    return this.toAccountAccessEntry(result.data);
  }

  private toAccountAccessEntry(bean: IAccountAccessEntryBean): AccountAccessEntry {
    if (!bean) { throw new Error("bean is empty!!!"); }

    const result = new AccountAccessEntry();
    result.accountCode = bean.accountCode;
    result.isExpired = !!bean.isExpired;
    return result;
  }
  
  async registerNewAccount(entryGuid: string, accountCode: string, password: string): Promise<NewAccountRegisterResult> {
    const url = "/api/account";
    const request: INewAccountRegisterRequestBean = {
      entryGuid: entryGuid,
      accountCode: accountCode,
      password: password,
    };
    const result = await this.post(url, request);
    return this.toNewAccountRegisterResult(result.data);
  }

  private toNewAccountRegisterResult(bean: INewAccountRegisterResultBean): NewAccountRegisterResult {
    if (!bean) { throw new Error("bean is empty!!!"); }

    const result = new NewAccountRegisterResult();
    result.isOk = !!bean.isOk;
    result.isAlreadyRegistered = !!bean.isAlreadyRegistered;
    result.isExpired = !!bean.isExpired;
    return result;
  }

  async registerAccountPasswordResetEntry(accountCode: string): Promise<ResetPasswordEntryResult> {
    const url = "/api/account/reset-password-entry";
    const request: IResetPasswordEntryRequestBean = {
      accountCode: accountCode,
    };
    const result = await this.post(url, request);
    return this.toResetPasswordEntryResult(result.data);
  }

  private toResetPasswordEntryResult(bean: IResetPasswordEntryResultBean): ResetPasswordEntryResult {
    if (!bean) { throw new Error("bean is empty!!!"); }

    const result = new ResetPasswordEntryResult();
    result.isOk = !!bean.isOk;
    result.isAccountCodeInvalid = !!bean.isAccountCodeInvalid;
    result.isMailSendFailed = !!bean.isMailSendFailed;
    return result;
  }

  async resetPassword(entryGuid: string, accountCode: string, newPassword: string): Promise<ResetPasswordRegisterResult> {
    const url = "/api/account/reset-password";
    const request: IResetPasswordRegisterRequestBean = {
      entryGuid: entryGuid,
      accountCode: accountCode,
      newPassword: newPassword,
    };
    const result = await this.post(url, request);
    return this.toResetPasswordRegisterResult(result.data);
  }

  private toResetPasswordRegisterResult(bean: IResetPasswordRegisterResultBean): ResetPasswordRegisterResult {
    if (!bean) { throw new Error("bean is empty!!!"); }

    const result = new ResetPasswordRegisterResult();
    result.isOk = !!bean.isOk;
    result.isExpired = !!bean.isExpired;
    return result;
  }
}
